/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Row, message } from "antd";
import React, { useCallback, useEffect, useReducer } from "react";
import TabUnderLine from "../../../../../components/TabUnderLine";
import { _ } from "../../../../../utils";
import ModalControl from "../ModalControl";
import BillHistory from "./components/BillHistory";
import ContactHistory from "./components/contact-history";
import Info from "./components/Info";
import MemberHistory from "./components/MemberHistory";
import PreviewModal from "./components/PreviewModal";
import MemberProfileContext, { initState, reducer } from "./reducer";
import ImportantInformation from "./components/important-information";

const Index = ({ visible, setVisible, partnerCode, refId, refType }) => {
  const [state, dispatch] = useReducer(reducer, initState);

  const handleClickProcess = useCallback(
    (e) => {
      if (state.hasUnsavedChanges && e !== state.tabActive) {
        message.warning(
          "มีข้อมูลที่ยังไม่ได้บันทึก กรุณาบันทึกหรือยกเลิกข้อมูลก่อนเปลี่ยนเมนู"
        );
        return;
      }
      dispatch({
        type: "setState",
        payload: { name: "tabActive", value: e },
      });
    },
    [state.hasUnsavedChanges, state.tabActive]
  );

  const handleClose = () => {
    if (state.hasUnsavedChanges) {
      message.warning(
        "มีข้อมูลที่ยังไม่ได้บันทึก กรุณาบันทึกหรือยกเลิกข้อมูลก่อนปิดหน้าต่าง"
      );
      return;
    }
    setVisible(false);
    dispatch({
      type: "clear",
    });
  };

  useEffect(() => {
    if (visible)
      dispatch({
        type: "setGlobalState",
        payload: {
          name: "data",
          value: {
            partner_code: partnerCode,
            ref_id: refId,
            ref_type: refType,
          },
        },
      });
  }, [visible, partnerCode, refId, refType]);

  return (
    <MemberProfileContext.Provider value={{ state, dispatch }}>
      <ModalControl
        visible={visible}
        width={1000}
        footerLine={false}
        destroyOnClose={true}
        onCancel={handleClose}
      >
        <TabUnderLine
          active={state.tabActive}
          list={state.listTab}
          onClick={handleClickProcess}
        />
        <Row className="mt-3">
          <Col span={24}>
            <div className={state.tabActive !== "info" && "d-none"}>
              <Info
                hiding={state.tabActive !== "info"}
                partnerCode={state.data.partner_code}
                refId={state.data.ref_id}
                refType={state.data.ref_type}
              />
            </div>

            <div className={state.tabActive !== "member" && "d-none"}>
              <MemberHistory />
            </div>

            {_.includes(["sale", "redeem"], state.tabActive) && (
              <BillHistory salesType={state.tabActive} />
            )}

            <div className={state.tabActive !== "contact" && "d-none"}>
              <ContactHistory />
            </div>

            <div className={state.tabActive !== "important" && "d-none"}>
              <ImportantInformation />
            </div>
          </Col>
        </Row>
        {state.tabActive === "member" && <PreviewModal />}
      </ModalControl>
    </MemberProfileContext.Provider>
  );
};

export default Index;
